/* eslint-disable jsx-a11y/label-has-associated-control  */
import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';

import { useFormContext } from 'react-hook-form';
import { IdeaTemplateSelectCard } from './IdeaTemplateSelectCard';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    wrp:{
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title:{
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1.25rem',
        margin: '0 0 1rem 0', 
        textAlign: 'left',
        color:"#333",
      },
    fieldsetBox:{
        marginBottom:theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
         
    },
   
    labelname:{
        fontFamily: 'VodafoneRg-bold', 
        margin: '0 0 0.5rem 0', 
        fontSize: '1.125rem',
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    text:{
        fontFamily: 'VodafoneRg-regular', 
        margin: '0 0 0.5rem 0', 
        fontSize: '1rem',
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    error:{
        color:"red",
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
    },
    wrpcols:{
        display: 'grid',
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: '1rem',
        marginBottom:theme.spacing(2)
    },
  }));
  

export const SelectIdeaTemplate = (props) => {
const {listIdeaTemplate} = props || {}
const classes = useStyles();
const { setValue, trigger, getValues, formState: { errors } } = useFormContext();
const [selectedTemplate, setSelectedTemplate] = React.useState(null);

useEffect(() => {
    const savedTemplate = getValues('templateIdea');
    if (savedTemplate) {
        setSelectedTemplate(savedTemplate);
    }
}, []);

const handleSelect = (template) => {
    setSelectedTemplate(template);
    setValue('templateIdea', template, { shouldValidate: true }); // update + validate
    trigger('templateIdea'); // manually trigger validation
};

    
  return (
    <div className={classes.wrp}>
        <h2 className={classes.title}>Select Idea Template</h2>
        <span className={classes.text}>Choose a template that best fits your challenge Requirements.</span>
            {errors?.templateIdea && (
                <p className={classes.error}>{errors.templateIdea.message}</p>
            )}
            <div className={classes.wrpcols}>
                {listIdeaTemplate?.map((idealist, index) => (
                    <IdeaTemplateSelectCard
                        key={idealist.templateName}
                        ideaName={idealist.templateName}
                        currentIndex={index}
                        onClick={() => handleSelect(idealist)}
                        idealistId={idealist.id}
                        selectedTemplateId={selectedTemplate?.id}
                    />
                ))}
            </div>

            {selectedTemplate && (
                <h3 className={classes.title}>Selected Template: {selectedTemplate?.templateName}</h3>
            )}
        </div>

        
    //   {selectedTemplate &&   <h3 className={classes.title}>Selected Template : {selectedTemplate?.templateName}</h3> }
    // </div>
  )
}



